import React, { useEffect, useState } from "react";
import { Col, Card } from "react-bootstrap";
import axios from "axios";
import { Chart } from "react-google-charts";
import moment from "moment";

const WorldMapHeatMap = ({ queryParam }) => {
  const [countryDistribution, setCountryDistribution] = useState([]);
  const [referenceDate, setReferenceDate] = useState(null);

  const options = {
    colorAxis: {
      colors: ["FFDBDB", "#F7CBCB", "#E55353", "#893232"],
    },
    backgroundColor: "#fff",
    datalessRegionColor: "#f5f5f5",
    defaultColor: "#f5f5f5",
  };

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_EAS_BASE_URL}/api/ransomware/records-by-country${queryParam}`,
        {
          headers: {
            apikey: process.env.REACT_APP_EAS_API_KEY,
            "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
          },
        }
      )
      .then((response) => {
        setCountryDistribution(
          response?.data?.country_records ? response?.data?.country_records : []
        );
        setReferenceDate(response?.data?.earliest_date);
      });
  }, [queryParam]);

  return (
    <Col md={12} className="mb-4">
      <Card>
        <Card.Body style={{ maxHeight: "320px" }}>
          <h6 className="fw-bold text-muted">
            {`Targeted Countries Distribution`}
            {/**
           * <span className="text-muted" style={{ fontSize: "12px" }}>
          <i>{`(Since ${moment(referenceDate).format("MMM YYYY")})`}</i>
        </span>
           */}
          </h6>
          <Chart
            chartEvents={[
              {
                eventName: "select",
                callback: ({ chartWrapper }) => {
                  const chart = chartWrapper.getChart();
                  const selection = chart.getSelection();
                  if (selection.length === 0) return;
                  const region = [
                    ["Country", "Ransomware Incidents"],
                    ...countryDistribution
                      .map((geo) => {
                        if (geo?.country)
                          return [geo.country, geo.record_count];
                      })
                      .filter((item) => item !== undefined),
                  ][selection[0].row + 1];
                  console.log("Selected : " + region);
                },
              },
            ]}
            chartType="GeoChart"
            width="100%"
            height="270px"
            options={options}
            data={[
              ["Country", "Ransomware Incidents"],
              ...countryDistribution
                .map((geo) => {
                  if (geo?.country) return [geo.country, geo.record_count];
                })
                .filter((item) => item !== undefined),
            ]}
          />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default WorldMapHeatMap;
